import React from 'react';
import { Link } from 'react-router-dom';
import './ManuscriptList.css';
import { useManuscripts } from './ManuscriptContext';

const ManuscriptList = () => {
  const { manuscripts, loading, error } = useManuscripts();

  if (loading) {
    return (
      <div className="container">
        <div className="main">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <div className="loading-text">Loading manuscripts...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="error highlight">{error}</div>;
  }

  return (
    <div className="container">
      <div className="main">        
        <div className="manuscripts-grid">
          {manuscripts.map((manuscript) => (
            <div key={manuscript.manuscript_id} className="manuscript-card">
              <div className="card">
                <div className="card-image-container">
                  <Link to={`/manuscript/${manuscript.manuscript_id}`}>
                    <img
                      src={`/msdata/${manuscript.manuscript_id}/img/thumbnails/1.jpg`}
                      alt={`First folio of ${manuscript.title_lat}`}
                      className="card-image"
                    />
                  </Link>
                </div>
                <div className="card-content">
                  {manuscript.section && (
                    <div>{manuscript.section} من</div>
                  )}
                  <div className='ms-title'>{manuscript.title_ar}</div>
                  <div className='ms-author'>ل{manuscript.author_ar}</div>
                  <div className='ms-title'>{manuscript.title_lat}</div>
                  <div>by {manuscript.author_lat} (d. {manuscript.date})</div>
                </div>
                <div className="card-links">
                  <Link to={`/manuscript/${manuscript.manuscript_id}`} className="viewer-link">
                    View Details
                  </Link>
                  <Link to={`/viewer/${manuscript.manuscript_id}`} className="viewer-link">
                    Open Viewer
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ManuscriptList;